<!--<img class="dust" src="../assets/dust.svg" />-->

<app-navbar class="d-xl-none d-lg-none d-md-none"></app-navbar>

<ngb-alert [type]="'danger'" *ngIf="userIsAuthenticated && false">
  Hemos migrado a un nuevo servidor.<br />
  <strong>
    Por favor, abandone esta página y acceda a
    <a href="https://gestion.cookadhoc.com">gestion.cookadhoc.com </a>
  </strong>
</ngb-alert>

<div class="row main-row">
  <app-sidebar
    class="col-md-2 d-none d-md-block d-lg-block"
    *ngIf="userIsAuthenticated"
  >
  </app-sidebar>

  <div
    [className]="
      userIsAuthenticated
        ? 'col-md-10 offset-md-2 col-sm-12 col-xs-12 main'
        : 'col-12 main login'
    "
  >
    <router-outlet></router-outlet>
    <footer>
      v. {{ currentVersion }}<br />CookAdHoc<sup>®</sup> Cocina sin recetas.
      Desarrollado por
      <a target="_blank" href="https://francaballero.net">Fran Caballero</a>
      para <strong>Ali&Cia</strong> ©{{ currentYear }}
      <br />
      <a
        target="_blank"
        href="https://apps.apple.com/app/cookadhoc/id6446223541"
      >
        <img
          alt="App Store"
          src="https://app.cookadhoc.com/assets/img/app-store-es.png"
        />
      </a>
      <a
        target="_blank"
        href="https://play.google.com/store/apps/details?id=cookadhoc.cocina.sin.recetas"
      >
        <img
          alt="App Store"
          src="https://app.cookadhoc.com/assets/img/google-play-es.png"
        />
      </a>
    </footer>
  </div>
</div>
